<template>
  <div>
    <v-card class="mt-4">
      <v-card-text class="grey lighten-5">
        <h4>{{ title }}</h4>
        <div
          v-for="(errorObject, i) in errorsObject"
          :key="i"
        >
          <v-alert
            :value="true"
            color="error"
            icon="priority_high"
            outline
          >
            <div>{{ errorObject.errorMsg }}</div>
          </v-alert>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    errorsObject: {
      type: Array,
      default: null,
    },
  },
};
</script>
